import { z } from "zod";

export interface Resource {
  id?: number;
  depositoerp: number;
  tipo: number;
  nome: string;
  ativo: boolean;
}

export const schema = z.object({
  id: z.number().optional(),
  depositoerp: z.number().min(1, "Campo obrigatório"),
  nome: z.string().min(1, "Campo obrigatório"),
  tipo: z.number().min(1, "Campo obrigatório"),
  ativo: z.boolean(),
});

export type FormValues = z.infer<typeof schema>;

export function resourceToFormValues({
  ativo,
  depositoerp,
  ...values
}: Resource): FormValues {
  return {
    ...values,
    ativo: ativo,
    depositoerp: depositoerp,
  };
}

export function formValuesToResource({
  ativo,
  ...values
}: FormValues): Resource {
  return {
    ...values,
    ativo: ativo,
  };
}
